export default window._cmsContent['solar/select-address']